<template>
    <div class="incoming-power-wrap">
        <div style="display: flex; justify-content: space-between">
            <div class="incoming-radio-group leader-radio" style="text-align: center;">
                <el-radio-group
                    v-model="selectAccount"
                    v-for="item in accounts"
                    :key="item.elec_customer_account_id"
                    @change="toggleTab(item.elec_customer_account_id)"
                    size="medium"
                >
                    <el-radio-button
                        :label="item.account_name"
                        style="margin-right: 10px"
                    ></el-radio-button>
                </el-radio-group>
            </div>

            <div class="incoming-card-btn">
                <el-form
                    :inline="true"
                    :model="searchForm"
                    ref="searchForm"
                    :rules="searchFormRule"
                    class="leader-style-form"
                >
                    <el-form-item prop="selectDate" class="timePicker">
                        <el-date-picker
                            :picker-options="pickerDisabled"
                            v-model="searchForm.selectDate"
                            type="month"
                            placeholder="请选择时间"
                            :default-value="selectDate"
                            value-format="yyyy-MM"
                            format="yyyy-MM"
                            @change="yymm"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            icon="el-icon-caret-left"
                            @click="frontMonthClick"
                            size="medium"
                            class="time_btn"
                            >上一月</el-button
                        >
                        <el-button
                            @click="nextMonthClick"
                            :disabled="
                                this.sysDate === this.searchForm.selectDate
                            "
                            size="medium"
                            class="time_btn"
                        >
                            下一月
                            <i class="el-icon-caret-right"></i>
                        </el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            @click="search"
                            style="float:right;"
                            type="warning"
                            size="medium"
                            >查询</el-button
                        >
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <el-scrollbar style="height: 90%;">
            <div class="echart-container">
                <div class="btn-wrap">
                    <el-button
                        @click="showChart('chart')"
                        class="leader-common-button"
                        >图表</el-button
                    >
                    <el-button
                        @click="showChart('table')"
                        class="leader-common-button"
                        >数据</el-button
                    >
                    <!-- <el-button @click="exportFactors" class="leader-common-button"
                        >导出</el-button
                    > -->
                </div>
                <div class="mt15"></div>
                <v-chart
                    :auto-resize="true"
                    :options="demandBar"
                    ref="demandBar"
                    theme="ovilia-green"
                    v-show="showCharts"
                />
                <div v-show="!showCharts" class="common-table">
                    <common-table
                        :tableData="tableData"
                        :columns="cols"
                    ></common-table>
                </div>
            </div>
            <div class="echart-container" v-if="showDay == true">
                <div class="btn-wrap">
                    <el-button
                        @click="showChartDay('chart')"
                        class="leader-common-button"
                        >图表</el-button
                    >
                    <el-button
                        @click="showChartDay('table')"
                        class="leader-common-button"
                        >数据</el-button
                    >
                </div>
                <div class="chart_title">{{selectBarMonth}}</div>
                <v-chart
                    class="day-chart-class"
                    :auto-resize="true"
                    :options="dayDemandBar"
                    ref="dayDemandBar"
                    theme="ovilia-green"
                    v-show="showDay && showChartsDay"
                />
                <div v-show="showDay && !showChartsDay" class="common-table">
                    <common-table
                        :tableData="tableDataDay"
                        :columns="cols"
                    ></common-table>
                </div>
            </div>
            <div class="echart-container" v-if="showHour == true">
                <div class="btn-wrap">
                    <el-button
                        @click="showChartHour('chart')"
                        class="leader-common-button"
                        >图表</el-button
                    >
                    <el-button
                        @click="showChartHour('table')"
                        class="leader-common-button"
                        >数据</el-button
                    >
                </div>
                <div class="chart_title">{{selectBarHour}}</div>
                <v-chart
                    class="hour-chart-class"
                    :auto-resize="true"
                    :options="hourDemandBar"
                    ref="hourDemandBar"
                    theme="ovilia-green"
                    v-show="showHour && showChartsHour"
                    :loading="loading"
                />
                <div v-show="showHour && !showChartsHour" class="common-table">
                    <common-table
                        :tableData="tableDataHour"
                        :columns="cols"
                        v-loading="loading"
                    ></common-table>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>
<script>
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markArea";
import "echarts/lib/component/markPoint";
import CommonTable from "@/comon/components/common-table.vue";
import * as api from "@/http/hr";
import { getAccounts, getSysDate } from "@/http/api";
import utils from "@/utils/utils";
import moment from "moment";
export default {
    props: {
        date: {
            type: String,
            required: true
        },
        account_id: {
            type: String,
            required: true
        }
    },
    components: { CommonTable },
    data() {
        return {
            selectAccount: "", //选择的户号
            selectAccountId: "", //选择的户号id
            accounts: [], //户号列表
            sysDate: "", //系统时间
            searchForm: {
                selectDate: "" //选择的时间
            },
            pickerDisabled: {
                disabledDate: time => {
                    return (
                        time.getTime() >
                        new Date(
                            new Date(this.sysDate).toLocaleDateString()
                        ).getTime()
                    );
                }
            },
            searchFormRule: {
                selectDate: [
                    {
                        required: true,
                        message: "时间不能为空",
                        trigger: "change"
                    }
                ]
            },
            showCharts: true,
            showChartsDay: true,
            showChartsHour: true,
            tableData: [],
            tableDataDay: [],
            tableDataHour: [],
            cols: [
                { prop: "date", label: "时间" },
                { prop: "name", label: "功率因数" }
            ],
            max_area: "",
            less_area: "",
            over_area: "",
            xAxisData: [],
            yAxisData: [],
            showDay: false,
            showHour: false,
            xAxisDataDay: [],
            yAxisDataDay: [],
            xAxisDataHour: [],
            yAxisDataHour: [],
            selectBarMonth: '',
            selectBarHour: '',
            loading: false,
        };
    },
    created() {
        // 获取系统时间
        this.getSysDate();
    },
    mounted() {
        const demandBar = this.$refs.demandBar.chart;
        //使点击区域变成pointer
        demandBar.getZr().on("mousemove", function(params) {
            var pointInPixel = [params.offsetX, params.offsetY];
            if (demandBar.containPixel("grid", pointInPixel)) {
                demandBar.getZr().setCursorStyle("pointer");
            }
        });
        //折线图区域点击事件
        demandBar.getZr().on("click", params => {
            var pointInPixel = [params.offsetX, params.offsetY];
            var pointInGrid = demandBar.convertFromPixel("grid", pointInPixel);
            var category = demandBar.getModel().get("xAxis")[0].data[
                pointInGrid[0]
            ];
            if (undefined != category) {
                this.selectBarMonth = category;
                this.showDay = true;
                this.demandBarClick(category);
            }
        });
    },
    methods: {
        // 获取户号列表
        getAccounts() {
            getAccounts().then(res => {
                if (res && res.error_code === "0") {
                    this.accounts = res.bus_json;
                    this.selectAccount = res.bus_json[0].account_name;
                    this.selectAccountId =
                        res.bus_json[0].elec_customer_account_id;
                    this.getFactors();
                }
            });
        },
        // 获取系统时间
        getSysDate() {
            getSysDate().then(res => {
                if (res && res.error_code === "0") {
                    this.searchForm.selectDate = res.bus_json.sysdate3;
                    this.sysDate = res.bus_json.sysdate3;

                    // 获取户号
                    this.getAccounts();
                }
            });
        },
        demandBarClick(time) {
            api.getDayFactors({
                show_month: time,
                elec_customer_account_id: this.selectAccountId
            }).then(res => {
                if (res) {
                    this.xAxisDataDay = res.bus_json.x_list;
                    this.yAxisDataDay = res.bus_json.factor_list;
                    this.tableDataDay = [];
                    for (let i = 0; i < this.xAxisDataDay.length; i++) {
                        let obj = {};
                        obj.date = this.xAxisDataDay[i];
                        obj.name = this.yAxisDataDay[i];
                        this.tableDataDay.push(obj);
                    }

                    this.$nextTick(() => {
                        const dayDemandBar = this.$refs.dayDemandBar.chart;
                        //使点击区域变成pointer
                        dayDemandBar.getZr().on("mousemove", function(params) {
                            var pointInPixel = [params.offsetX, params.offsetY];
                            if (
                                dayDemandBar.containPixel("grid", pointInPixel)
                            ) {
                                dayDemandBar.getZr().setCursorStyle("pointer");
                            }
                        });
                        //折线图区域点击事件
                        dayDemandBar.getZr().on("click", params => {
                            var pointInPixel = [params.offsetX, params.offsetY];
                            var pointInGrid = dayDemandBar.convertFromPixel(
                                "grid",
                                pointInPixel
                            );
                            var category = dayDemandBar
                                .getModel()
                                .get("xAxis")[0].data[pointInGrid[0]];
                            if (undefined != category) {
                                this.selectBarHour = category;
                                this.showHour = true;
                                this.getHourFactorData(category);
                            }
                        });
                    });
                }
            });
        },
        getHourFactorData(time) {
            api.getHourFactors({
                show_day: time,
                elec_customer_account_id: this.selectAccountIdi
            }).then(res => {
                if (res) {
                    this.xAxisDataHour = res.bus_json.x_list;
                    this.yAxisDataHour = res.bus_json.factor_list;
                    
                    this.tableDataHour = [];
                    for (let i = 0; i < this.xAxisDataHour.length; i++) {
                        let obj = {}; 
                        obj.date = this.xAxisDataHour[i] + ' 时';
                        obj.name = this.yAxisDataHour[i];
                        this.tableDataHour.push(obj);
                    }
                }
            });
        },
        // 上一月
        frontMonthClick() {
            const now = moment(this.searchForm.selectDate);
            this.searchForm.selectDate = now
                .subtract(1, "months")
                .format("YYYY-MM");
            this.showDay = false;
            this.showHour = false;
            this.getFactors();
        },
        //下一月
        nextMonthClick() {
            const now = moment(this.searchForm.selectDate);
            this.searchForm.selectDate = now.add(1, "months").format("YYYY-MM");
            this.showDay = false;
            this.showHour = false;
            this.getFactors();
        },
        // 查询
        search() {
            this.$refs["searchForm"].validate(valid => {
                if (valid) {
                    this.showDay = false;
                    this.showHour = false;
                    this.getFactors();
                }
            });
        },
        getFactors() {
            this.loading = true;
            api.getFactors({
                elec_customer_account_id: this.selectAccountId,
                show_month: this.searchForm.selectDate
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.xAxisData = res.bus_json.x_list;
                    this.yAxisData = res.bus_json.factor_list;
                    
                    this.tableData = [];
                    for (let i = 0; i < this.xAxisData.length; i++) {
                        let obj = {};
                        obj.date = this.xAxisData[i];
                        obj.name = this.yAxisData[i];
                        this.tableData.push(obj);
                    }

                    this.max_area = res.bus_json.max_area;
                    this.less_area = res.bus_json.less_area;
                    this.over_area = res.bus_json.over_area;
                }
                this.loading = false;
            });
        },
        exportFactors() {
            api.exportFactors({
                elec_customer_account_id: this.selectAccountId,
                show_month: this.searchForm.selectDate
            }).then(res => {
                const content = res;
                const blob = new Blob([content]);
                const fileName = "功率因数" + ".xlsx";
                if ("download" in document.createElement("a")) {
                    const elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                } else {
                    navigator.msSaveBlob(blob, fileName);
                }
            });
        },
        // 图表数据转换
        showChart(type) {
            if (type === "chart") {
                this.showCharts = true;
            } else {
                this.showCharts = false;
            }
        },
         // 图表数据转换
        showChartDay(type) {
            if (type === "chart") {
                this.showChartsDay = true;
            } else {
                this.showChartsDay = false;
            }
        },
         // 图表数据转换
        showChartHour(type) {
            if (type === "chart") {
                this.showChartsHour = true;
            } else {
                this.showChartsHour = false;
            }
        },
        toggleTab(val) {
            this.selectAccountId = val;
            this.getFactors();
        }
    },
    computed: {
        demandBar() {
            const option = {
                title: {
                    text: "功率因数",
                    left: "center",
                    textStyle: {
                        color: "#fff"
                    }
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                legend: {
                    data: ["功率因数"],
                    textStyle: { fontSize: 12, color: "#fff" },
                    top: "8%"
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "8%",
                    containLabel: true
                },
                xAxis: [
                    {
                        type: "category",
                        axisLabel: {
                            color: "#5e8ac9",
                            fontSize: 14
                        },

                        axisLine: { lineStyle: { color: "#446594" } },
                        xAxisLeft: "#5e8ac9",
                        data: this.xAxisData
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        yAxisTop: "yellow",
                        nameTextStyle: {
                            color: "white",
                            padding: 10,
                            fontSize: 14
                        },
                        axisLabel: {
                            color: "#00dbf7",
                            fontSize: 14
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                // type:'dashed',
                                color: ["#446595"]
                            }
                        },
                        axisLine: { lineStyle: { color: "#446594" } },
                        xAxisLeft: "#5e8ac9"
                    }
                ],
                series: [
                    {
                        name: "功率因数",
                        type: "line",
                        itemStyle: {
                            normal: {
                                color: "#00dbf7"
                            }
                        },
                        barGap: "0%",
                        barWidth: "75%",
                        data: this.yAxisData,
                    }
                ]
            };
            return option;
        },
        dayDemandBar() {
            const option = {
                title: {
                    text: "功率因数",
                    left: "center",
                    textStyle: {
                        color: "#fff"
                    }
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                legend: {
                    data: ["功率因数"],
                    textStyle: { fontSize: 12, color: "#fff" },
                    top: "8%"
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "8%",
                    containLabel: true
                },
                xAxis: [
                    {
                        type: "category",
                        axisLabel: {
                            color: "#5e8ac9",
                            fontSize: 14
                        },

                        axisLine: { lineStyle: { color: "#446594" } },
                        xAxisLeft: "#5e8ac9",
                        data: this.xAxisDataDay
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        yAxisTop: "yellow",
                        nameTextStyle: {
                            color: "white",
                            padding: 10,
                            fontSize: 14
                        },
                        axisLabel: {
                            color: "#00dbf7",
                            fontSize: 14
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                // type:'dashed',
                                color: ["#446595"]
                            }
                        },
                        axisLine: { lineStyle: { color: "#446594" } },
                        xAxisLeft: "#5e8ac9"
                    }
                ],
                series: [
                    {
                        name: "功率因数",
                        type: "line",
                        itemStyle: {
                            normal: {
                                color: "#00dbf7"
                            }
                        },
                        barGap: "0%",
                        barWidth: "75%",
                        data: this.yAxisDataDay,
                    }
                ]
            };
            return option;
        },
        hourDemandBar() {
            const option = {
                title: {
                    text: "功率因数",
                    left: "center",
                    textStyle: {
                        color: "#fff"
                    }
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                legend: {
                    data: ["功率因数"],
                    textStyle: { fontSize: 12, color: "#fff" },
                    top: "8%"
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "8%",
                    containLabel: true
                },
                xAxis: [
                    {
                        type: "category",
                        axisLabel: {
                            color: "#5e8ac9",
                            fontSize: 14
                        },

                        axisLine: { lineStyle: { color: "#446594" } },
                        xAxisLeft: "#5e8ac9",
                        data: this.xAxisDataHour
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        yAxisTop: "yellow",
                        nameTextStyle: {
                            color: "white",
                            padding: 10,
                            fontSize: 14
                        },
                        axisLabel: {
                            color: "#00dbf7",
                            fontSize: 14
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                // type:'dashed',
                                color: ["#446595"]
                            }
                        },
                        axisLine: { lineStyle: { color: "#446594" } },
                        xAxisLeft: "#5e8ac9"
                    }
                ],
                series: [
                    {
                        name: "功率因数",
                        type: "line",
                        itemStyle: {
                            normal: {
                                color: "#00dbf7"
                            }
                        },
                        barGap: "0%",
                        barWidth: "75%",
                        data: this.yAxisDataHour,
                    }
                ]
            };
            return option;
        },
    },
    watch: {
        // date: {
        //     handler(newValue) {
        //         this.date = newValue;
        //         if (this.date && this.account_id) {
        //             this.getFactors();
        //         }
        //     },
        //     deep: true,
        //     immediate: true,
        // },
        // account_id: {
        //     handler(newValue) {
        //         this.account_id = newValue;
        //         if (this.account_id && this.date) {
        //             this.getFactors();
        //         }
        //     },
        //     deep: true,
        //     immediate: true,
        // },
    },
};
</script>
<style lang="scss">
.incoming-power-wrap {
    width: 100%;
    height: 100%;
    padding: px2Rem(20px);
    box-sizing: border-box;
    .incoming-radio-group {
    }
    .incoming-card-btn {
    }
    .el-scrollbar__view {
        height: 100%;
    }
    .el-scrollbar__wrap {
        padding-bottom: 0 !important;
    }
    .echart-container {
        width: 100%;
        height: 42%;
        background: url("../../../assets/image/index/table-bg.png") no-repeat;
        background-size: 100% 100%;
        padding-top: px2Rem(20px);
        margin-bottom: px2Rem(20px);
        position: relative;
        .chart_title {
            width: 100%;font-size: 18px;color: #fff;text-align: center;font-weight: bold;
        }
        .btn-wrap {
            // text-align: right;
            // height: px2Rem(50px);
            // line-height: px2Rem(50px);
            // margin-right: px2Rem(30px);
            position: absolute;
            top: 15px;
            right: 10px;
            z-index: 9;
        }
        .echarts {
            width: 100%;
          //  height: calc(100% - #{px2Rem(70px)});
          height: 100%;
        }
        .common-table {
            width: 100%;
           // height: calc(100% - #{px2Rem(70px)});
           height: 100%;
            padding: px2Rem(20px);
            box-sizing: border-box;
        }
    }
    .mt15{margin-top:15px}
}
</style>
